<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height background" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="8">
            <v-card class="elevation-12 rounded-lg">
              <v-window v-model="step">
                <!-- Login -->
                <v-window-item :value="1">
                  <v-row>
                    <v-col cols="12" md="8">
                      <v-card-text class="mt-12">
                        <!-- Titulo -->
                        <h1 class="text-center display-2 primary--text">
                          ENTRAR
                        </h1>

                        <!-- Subtitulo -->
                        <h4 class="text-center mt-4">
                          Preencha o formulário para entrar
                        </h4>

                        <!-- Alertas de erro -->
                        <v-alert
                          v-if="status_login['status'] === 'error'"
                          type="error"
                        >
                          {{ status_login["msg"] }}
                        </v-alert>

                        <v-form ref="form_login">
                          <!-- Usuario -->
                          <v-text-field
                            label="Usuario"
                            v-model.trim="form_login.username"
                            :rules="[rules.obrigatorio]"
                            prepend-icon="mdi-account"
                            type="text"
                            color="primary"
                            clear-icon="mdi-close-circle"
                            clearable
                          />

                          <!-- Senha -->
                          <v-text-field
                            label="Senha"
                            v-model.trim="form_login.password"
                            :rules="[rules.obrigatorio]"
                            id="password"
                            prepend-icon="mdi-lock"
                            color="primary"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            @click:append="show = !show"
                            clear-icon="mdi-close-circle"
                            clearable
                          />
                        </v-form>

                        <h3 class="text-center mt-4"></h3>
                      </v-card-text>

                      <div class="text-center mt-3 mb-3">
                        <v-btn
                          @click="login()"
                          class="rounded-lg"
                          color="botao_1"
                          dark
                        >ENTRAR</v-btn>

                        <br>

                        <EsqueciMinhaSenhaView />
                      </div>
                    </v-col>

                    <!-- Menu lateral -->
                    <v-col cols="12" md="4" class="primary">
                      <v-switch
                        label="Alterar tema"
                        v-model="$vuetify.theme.dark"
                        dark
                        class="mt-5 mx-2"
                        color="botao_1"
                        inset
                        persistent-hint
                      ></v-switch>

                      <v-card-text class="white--text mt-12">
                        <h1 class="text-center display-1">DINIZ FINANÇAS</h1>
                        <h5 class="text-center">
                          Ainda não tem cadastro? Venha fazer parte
                        </h5>
                      </v-card-text>

                      <div class="text-center mb-3">
                        <v-btn class="rounded-lg" outlined dark @click="step++"
                          >Fazer Cadastro</v-btn
                        >
                      </div>
                    </v-col>
                  </v-row>
                </v-window-item>

                <!-- Cadastro -->
                <v-window-item :value="2">
                  <v-row class="fill-height">
                    <v-col cols="12" md="4" class="primary">
                      <v-switch
                        label="Alterar tema"
                        v-model="$vuetify.theme.dark"
                        dark
                        class="mt-5 mx-2"
                        color="botao_1"
                        inset
                        persistent-hint
                      ></v-switch>

                      <v-card-text class="white--text mt-12">
                        <h1 class="text-center display-1">DINIZ FINANÇAS</h1>
                        <h5 class="text-center">
                          Já é cadastrado? clique no botão abaixo
                        </h5>
                      </v-card-text>

                      <div class="text-center">
                        <v-btn rounded-lg outlined dark @click="step--"
                          >Fazer Login</v-btn
                        >
                      </div>
                    </v-col>

                    <v-col cols="12" md="8">
                      <v-card-text class="mt-12">
                        <!-- Titulo -->
                        <h1 class="text-center display-2 primary--text">
                          CADASTRAR
                        </h1>

                        <!-- Subtitulo -->
                        <h4 class="text-center mt-4">
                          Preencha o formulário de cadastro
                        </h4>

                        <!-- Alerta ERROR -->
                        <v-alert
                          v-if="status_cadastro['status'] === 'error'"
                          type="error"
                        >
                          {{ status_cadastro["msg"] }}
                        </v-alert>
                        <!-- Alerta OK -->
                        <v-alert
                          v-if="status_cadastro['status'] === 'ok'"
                          type="success"
                        >
                          {{ status_cadastro["msg"] }}
                        </v-alert>

                        <v-form ref="form_cadastro">
                          <v-text-field
                            label="Usuario"
                            v-model.trim="form_cadastro.usuario"
                            :rules="[rules.obrigatorio, rules.min_3]"
                            prepend-icon="mdi-account"
                            type="text"
                            color="primary"
                            :maxlength="50"
                            clear-icon="mdi-close-circle"
                            clearable
                          />

                          <v-text-field
                            label="E-mail"
                            v-model.trim="form_cadastro.email"
                            :rules="[rules.obrigatorio, rules.email]"
                            prepend-icon="mdi-email"
                            type="email"
                            color="primary"
                            clear-icon="mdi-close-circle"
                            clearable
                          />

                          <v-text-field
                            label="Senha"
                            v-model.trim="form_cadastro.senha1"
                            :rules="[rules.obrigatorio, rules.min_8]"
                            id="password1"
                            prepend-icon="mdi-lock"
                            color="primary"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            @click:append="show = !show"
                            :counter="8"
                            :maxlength="8"
                            clear-icon="mdi-close-circle"
                            clearable
                          />

                          <v-text-field
                            label="Repita a Senha"
                            v-model.trim="form_cadastro.senha2"
                            :rules="[
                              rules.obrigatorio,
                              rules.min_8,
                              () =>
                                form_cadastro.senha1 == form_cadastro.senha2 ||
                                'As senhas devem ser iguais',
                            ]"
                            id="password2"
                            prepend-icon="mdi-lock"
                            color="primary"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            @click:append="show = !show"
                            :counter="8"
                            :maxlength="8"
                            clear-icon="mdi-close-circle"
                            clearable
                          />
                        </v-form>
                      </v-card-text>

                      <div class="text-center mt-n5 mb-3">
                        <v-btn
                          @click="cadastro()"
                          rounded-lg
                          color="botao_1"
                          dark
                          >CADASTRAR</v-btn
                        >
                      </div>
                    </v-col>
                  </v-row>
                </v-window-item>
              </v-window>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import verifica_autenticado from "@/utils/verifica_autenticado";
import EsqueciMinhaSenhaView from "@/utils/esqueciMinhaSenha/EsqueciMinhaSenhaView";

export default {
  name: "AuthView",

  components: {
    EsqueciMinhaSenhaView,
  },

  data: () => ({
    step: 1,
    form_login: {},
    form_cadastro: {
      usuario: "",
      senha1: "",
      senha2: "",
    },
    show: false,
    status_login: { status: "null" },
    status_cadastro: { status: "null" },
    rules: {
      obrigatorio: (v) => !!v || "Este campo é obrigatório",
      min_8: (v) => v.length >= 8 || "Mínimo 8 caracteres",
      min_3: (v) => v.length >= 3 || "Mínimo 3 caracteres",
      email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail inválido'
    },
  }),

  props: {
    source: String,
  },

  methods: {
    ...mapActions(["AuthLoginAction", "AuthCadastroAction"]),

    ...mapGetters(["getResponseCadastro"]),

    ...mapMutations(["CarregandoMutation"]),

    async login() {
      if (this.$refs.form_login.validate()) {
        await this.AuthLoginAction(this.form_login);

        if (verifica_autenticado()) {
          this.$router.push("financas");
        } else {
          this.status_login = {
            status: "error",
            msg: "Usuario ou senha incorretos",
          };
        }
      }
    },

    async cadastro() {
      if (this.$refs.form_cadastro.validate()) {
        await this.AuthCadastroAction(this.form_cadastro);
        this.status_cadastro = this.getResponseCadastro();
      }
    },
  },
};
</script>
